import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);

// Global UI strings for both languages
export const STRINGS = {
  nav: {
    services: { es: "Servicios", en: "Services" },
    destinations: { es: "Destinos", en: "Destinations" },
    transfers: { es: "Tarifas", en: "Rates" },
    experiences: { es: "Experiencias", en: "Experiences" },
    contact: { es: "Contacto", en: "Contact" },
    book: { es: "Reservar", en: "Book now" },
  },
  hero: {
    kicker: { es: "Cancún · Riviera Maya", en: "Cancún · Riviera Maya" },
    title: { es: "Tu traslado privado al paraíso de Riviera Maya", en: "Your private transfer to the Riviera Maya paradise" },
    subtitle: {
      es: "Transportación premium desde el aeropuerto de Cancún a los hoteles y parques de toda la zona. Choferes bilingües, unidades nuevas y servicio puntual 24/7.",
      en: "Premium transportation from Cancún airport to hotels and parks throughout the area. Bilingual drivers, new vehicles and punctual 24/7 service.",
    },
    ctaBook: { es: "Reservar mi traslado", en: "Book my transfer" },
    ctaRates: { es: "Ver tarifas", en: "View rates" },
    stat1: { es: "Servicio", en: "Service" },
    stat2: { es: "Clientes felices", en: "Happy clients" },
    stat3: { es: "Bilingüe", en: "Bilingual" },
  },
  services: { kicker: { es: "Lo que hacemos", en: "What we do" }, title: { es: "Servicios de transportación", en: "Transportation services" }, sub: { es: "Cubrimos cada momento de tu viaje, desde que aterrizas hasta tu regreso.", en: "We cover every moment of your trip, from landing to your return." } },
  destinations: { kicker: { es: "Destinos", en: "Destinations" }, title: { es: "Te llevamos a donde quieras", en: "We take you wherever you want" }, sub: { es: "Hoteles y parques del complejo Xcaret y la Riviera Maya.", en: "Hotels and parks of the Xcaret complex and the Riviera Maya." } },
  transfers: { kicker: { es: "Tarifas", en: "Rates" }, title: { es: "Precios de referencia", en: "Reference prices" }, sub: { es: "Tarifas por servicio privado (precios de ejemplo en USD). Confirmamos el precio final al reservar.", en: "Private service rates (sample prices in USD). We confirm the final price when booking." }, colRoute: { es: "Ruta", en: "Route" }, colVehicle: { es: "Vehículo", en: "Vehicle" }, colPrice: { es: "Por persona", en: "Per person" }, note: { es: "* Precios por persona. Sujetos a disponibilidad y temporada.", en: "* Prices per person. Subject to availability and season." }, add: { es: "Agregar", en: "Add" }, persons: { es: "Personas", en: "Persons" }, perPerson: { es: "por persona", en: "per person" } },
  experiences: { kicker: { es: "Experiencias", en: "Experiences" }, title: { es: "Tours y parques inolvidables", en: "Unforgettable tours & parks" }, sub: { es: "Reserva tus experiencias favoritas y las coordinamos con tu traslado.", en: "Book your favorite experiences and we coordinate them with your transfer." }, perPerson: { es: "por persona", en: "per person" }, add: { es: "Agregar al carrito", en: "Add to cart" } },
  whyus: { kicker: { es: "Por qué elegirnos", en: "Why choose us" }, title: { es: "Viaja con tranquilidad", en: "Travel with peace of mind" } },
  testimonials: { kicker: { es: "Testimonios", en: "Testimonials" }, title: { es: "Lo que dicen nuestros clientes", en: "What our clients say" } },
  form: {
    kicker: { es: "Reserva en línea", en: "Book online" },
    title: { es: "Solicita tu traslado", en: "Request your transfer" },
    sub: { es: "Completa el formulario y te confirmamos por WhatsApp en minutos.", en: "Fill in the form and we confirm via WhatsApp in minutes." },
    name: { es: "Nombre completo", en: "Full name" },
    phone: { es: "Teléfono / WhatsApp", en: "Phone / WhatsApp" },
    email: { es: "Correo electrónico", en: "Email" },
    serviceType: { es: "Tipo de servicio", en: "Service type" },
    tripType: { es: "Tipo de viaje", en: "Trip type" },
    passengers: { es: "Pasajeros", en: "Passengers" },
    origin: { es: "Origen", en: "Origin" },
    destination: { es: "Destino", en: "Destination" },
    date: { es: "Fecha", en: "Date" },
    time: { es: "Hora", en: "Time" },
    flight: { es: "Número de vuelo (opcional)", en: "Flight number (optional)" },
    notes: { es: "Notas adicionales", en: "Additional notes" },
    submit: { es: "Enviar y abrir WhatsApp", en: "Send and open WhatsApp" },
    oneway: { es: "Solo ida", en: "One way" },
    roundtrip: { es: "Ida y vuelta", en: "Round trip" },
    st_airport_hotel: { es: "Aeropuerto → Hotel", en: "Airport → Hotel" },
    st_hotel_airport: { es: "Hotel → Aeropuerto", en: "Hotel → Airport" },
    st_park: { es: "Traslado a Parques", en: "Park Transfer" },
    st_tour: { es: "Tour Riviera Maya / Tulum", en: "Riviera Maya / Tulum Tour" },
  },
  contact: { kicker: { es: "Contacto", en: "Contact" }, title: { es: "¿Listo para reservar?", en: "Ready to book?" }, sub: { es: "Escríbenos por WhatsApp o llena el formulario. Te respondemos al instante.", en: "Message us on WhatsApp or fill in the form. We reply instantly." }, whatsapp: { es: "Escribir por WhatsApp", en: "Message on WhatsApp" }, call: { es: "Llamar ahora", en: "Call now" } },
  cart: {
    title: { es: "Tu carrito", en: "Your cart" },
    empty: { es: "Tu carrito está vacío", en: "Your cart is empty" },
    emptySub: { es: "Agrega traslados o experiencias para continuar.", en: "Add transfers or experiences to continue." },
    subtotal: { es: "Subtotal", en: "Subtotal" },
    total: { es: "Total", en: "Total" },
    checkout: { es: "Proceder al pago", en: "Proceed to checkout" },
    continue: { es: "Seguir explorando", en: "Keep browsing" },
    qty: { es: "Cantidad", en: "Qty" },
    remove: { es: "Quitar", en: "Remove" },
    transfer: { es: "Traslado", en: "Transfer" },
    experience: { es: "Experiencia", en: "Experience" },
  },
  checkout: {
    title: { es: "Finalizar compra", en: "Checkout" },
    sub: { es: "Completa tus datos para confirmar la reserva.", en: "Complete your details to confirm the booking." },
    name: { es: "Nombre completo", en: "Full name" },
    email: { es: "Correo electrónico", en: "Email" },
    phone: { es: "Teléfono / WhatsApp", en: "Phone / WhatsApp" },
    method: { es: "Método de pago", en: "Payment method" },
    card: { es: "Tarjeta", en: "Card" },
    payWhatsapp: { es: "Confirmar por WhatsApp", en: "Confirm via WhatsApp" },
    pay: { es: "Pagar", en: "Pay" },
    success: { es: "¡Reserva confirmada!", en: "Booking confirmed!" },
    successSub: { es: "Gracias por tu compra. Te enviaremos los detalles por correo y WhatsApp.", en: "Thank you for your purchase. We'll send the details by email and WhatsApp." },
    close: { es: "Cerrar", en: "Close" },
    demoNote: { es: "Pago simulado (demo). La pasarela de pago se integrará próximamente.", en: "Simulated payment (demo). The payment gateway will be integrated soon." },
  },
  footer: { rights: { es: "Todos los derechos reservados.", en: "All rights reserved." }, tagline: { es: "Transportación privada premium en Cancún y Riviera Maya.", en: "Premium private transportation in Cancún and Riviera Maya." } },
  added: { es: "Agregado al carrito", en: "Added to cart" },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("xp_lang") || "es");

  useEffect(() => {
    localStorage.setItem("xp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((p) => (p === "es" ? "en" : "es"));

  // Translate a {es, en} object OR a top-level STRINGS path is handled by tt
  const t = (obj) => (obj && typeof obj === "object" ? obj[lang] : obj);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, S: STRINGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
